export default class {
	itensPedido
	justificativa
	quantidadeEstorno
	cancelarDocumentosJuntados
	constructor(itensPedido, justificativa, quantidadeEstorno) {
		this.itensPedido = itensPedido
		this.quantidadeEstorno = quantidadeEstorno
		this.justificativa = justificativa
	}
}
